var _g;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgOutlineEditForm(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 24,
    height: 24,
    viewBox: "0 0 24 24",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    fill: "{props.color}",
    fillRule: "evenodd"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M8,22.8c-3.7,0-5.8-2.1-5.8-5.8V7c0-3.7,2.1-5.8,5.8-5.8h8c3.6,0,5.8,2.1,5.8,5.8v10 c0,3.6-2.1,5.8-5.8,5.8H8z M3.8,7v10c0,2.9,1.4,4.2,4.2,4.2h8c2.9,0,4.2-1.4,4.2-4.2V7c0-2.9-1.4-4.2-4.2-4.2H8 C5.1,2.8,3.8,4.1,3.8,7z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M16.5,9.2c-1.5,0-2.8-1.2-2.8-2.8v-2 c0-0.4,0.3-0.8,0.8-0.8s0.8,0.3,0.8,0.8v2c0,0.7,0.6,1.2,1.2,1.2h2c0.4,0,0.8,0.3,0.8,0.8s-0.3,0.8-0.8,0.8H16.5z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M6.4,19.2C6.1,18.9,6,18.4,6,18l0.2-1.4 c0.1-0.4,0.3-0.8,0.5-1l3.6-3.6c1.5-1.4,2.7-0.6,3.3,0c0.6,0.6,0.9,1.2,0.8,1.8c-0.1,0.5-0.3,1-0.8,1.5l-3.6,3.6 c-0.2,0.3-0.7,0.5-1,0.5l-1.4,0.2c-0.1,0-0.2,0-0.2,0C7.1,19.6,6.7,19.5,6.4,19.2z M7.8,16.6c0,0-0.1,0.1-0.1,0.2l-0.2,1.3 l1.3-0.2c0,0,0.1-0.1,0.2-0.1l3.6-3.6c0.2-0.2,0.3-0.4,0.4-0.6c0-0.2-0.2-0.5-0.4-0.6c-0.5-0.5-0.8-0.5-1.2,0L7.8,16.6z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M12.5,16c-1.3-0.4-2.4-1.4-2.8-2.8 c-0.1-0.4,0.1-0.8,0.5-0.9c0.4-0.1,0.8,0.1,0.9,0.5c0.2,0.8,0.9,1.5,1.8,1.8c0.4,0.1,0.6,0.5,0.5,0.9C13.3,15.8,13,16,12.7,16 C12.6,16,12.5,16,12.5,16z"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgOutlineEditForm);
export default __webpack_public_path__ + "static/media/outline-edit-form.8e43e39a187ceeb3e10f56a6a9afc6d7.svg";
export { ForwardRef as ReactComponent };